export const SIGNALS = {
  hubletTag_0: "hubletTag_0",
  workflow_0: "workflow_0",
  plcTags_0: "plcTags_0",
  grossCount_0: "grossCount_0",
  rejectCount_0: "rejectCount_0",
  netCount_0: "netCount_0",
  opsku_0: "opsku_0",
  call_0: "call_0",
};
export const SIGNALS_DEBUG_TIMELINES = {
  grossCount_0: "grossCount_0",
  rejectCount_0: "rejectCount_0",
  netCount_0: "netCount_0",
};

export type Measurement = {
  ts: number;
  v: {
    id?: string;
    payload?: {
      machineState?: string;
      path?: string[];
      reason?: string;
    };
    location?: {
      value?: string;
    };
    current: {
      workflowState: string;
      tagStartTime: number;
      loggedInUserIdStartTime: number;
      tagId: null;
      opId: string;
      displayLayout: string;
      callNotificationGroupId: null;
      teamSizeStartTime: number;
      teamSize: number;
      skuId: string;
      opSku: string;
      stationId: string;
      batchQuantity: null;
      tagPath: [];
      opSkuStartTime: number;
      callStartTime: number;
      rateRange: string;
      workflowStateStartTime: number;
      rateRangeStartTime: number;
      loggedInUserId: null;
    };
  };
};
export const MOCK_MEASUREMENT: Measurement = {
  ts: 1685703318.935,
  v: {
    current: {
      workflowState: "Idle",
      tagStartTime: 1685700533.103,
      loggedInUserIdStartTime: 1617214492.999,
      tagId: null,
      opId: "",
      displayLayout: "MACHINE_UI",
      callNotificationGroupId: null,
      teamSizeStartTime: 1617214492.999,
      teamSize: 1,
      skuId: "",
      opSku: "no_sku_selected",
      stationId: "",
      batchQuantity: null,
      tagPath: [],
      opSkuStartTime: 1685703318.934,
      callStartTime: 1675348841.996,
      rateRange: "defaultIdle",
      workflowStateStartTime: 1685699965.138,
      rateRangeStartTime: 1685699965.138,
      loggedInUserId: null,
    },
  },
};
